{
  "aws_project_region": "eu-west-1",
  "aws_cloud_logic_custom": [
    {
      "name": "businessCentral",
      "endpoint": "https://ak4o0woogk.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    },
    {
      "name": "cognito",
      "endpoint": "https://5ifaqhhap0.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    },
    {
      "name": "profilePicture",
      "endpoint": "https://8e1jix2ywi.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    },
    {
      "name": "sendMail",
      "endpoint": "https://zra1un35p5.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    },
    {
      "name": "transformData",
      "endpoint": "https://gdauh7k1yk.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    },
    {
      "name": "userGroups",
      "endpoint": "https://ykfr4sp7mb.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    },
    {
      "name": "validateAddress",
      "endpoint": "https://t5y4w3kk3m.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    },
    {
      "name": "whise",
      "endpoint": "https://289k9057xh.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    }
  ],
  "aws_appsync_graphqlEndpoint": "https://ymbw3in2tfbxncplytm642rt5i.appsync-api.eu-west-1.amazonaws.com/graphql",
  "aws_appsync_region": "eu-west-1",
  "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
  "aws_cognito_identity_pool_id": "eu-west-1:20639a2f-5a14-4f8f-8d68-7bbb21750002",
  "aws_cognito_region": "eu-west-1",
  "aws_user_pools_id": "eu-west-1_t5H9qceY5",
  "aws_user_pools_web_client_id": "74s5jhn219eqodgb0fp4fh97hl",
  "oauth": {
    "domain": "latouretpetit-prod-sso.auth.eu-west-1.amazoncognito.com"
  },
  "aws_cognito_username_attributes": [],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS"
    ]
  },
  "aws_cognito_verification_mechanisms": [],
  "aws_user_files_s3_bucket": "latouretpetitfd64f2d1ba5c44ecbbf1a3260cd450cb04028-prod",
  "aws_user_files_s3_bucket_region": "eu-west-1"
}